"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('underscore'),
  chain = _require.chain,
  isString = _require.isString;
var languages = require('src/utils/languages');
var LanguagePicker = /*#__PURE__*/function () {
  LanguagePicker.$inject = ["EventEmitter"];
  /* @ngInject */
  function LanguagePicker(EventEmitter) {
    _classCallCheck(this, LanguagePicker);
    this.EventEmitter = EventEmitter;
    this.languages = languages.getAllLanguages();
    var languageNames = languages.getAllNames();
    var self = this;
    this.searchConfig = {
      minimumInputLength: 2,
      placeholder: 'Select a language',
      initSelection: function initSelection(element, cb) {
        cb(self.model);
      },
      query: function query(_query) {
        var currentCode = self.serialize();
        var queryTerm = _query.term.toLowerCase();
        var disabledLangs = chain(self.disabledLangs).without(currentCode).map(languages.getName).value();
        var results = chain(languageNames).filter(function (name) {
          var startsWithQuery = name.toLowerCase().startsWith(queryTerm);
          var isNotDisabled = !disabledLangs.includes(name);
          return startsWithQuery && isNotDisabled;
        }).uniq().map(function (name) {
          var code = languages.getCode(name);
          return {
            id: code,
            text: name
          };
        }).value();
        _query.callback({
          results: results
        });
      }
    };
  }
  _createClass(LanguagePicker, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.modalRegisterSerialize(this.EventEmitter({
        serialize: function serialize() {
          return _this.serialize();
        }
      }));
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.model) {
        var code = changes.model.currentValue;
        this.model = {
          id: code,
          text: languages.getName(code)
        };
      }
    }
  }, {
    key: "update",
    value: function update(oldVal) {
      var newVal = this.serialize();
      if (newVal !== oldVal) {
        this.onChange(this.EventEmitter({
          model: newVal
        }));
      }
      if (isString(newVal)) {
        this.model = {
          id: newVal,
          text: languages.getName(newVal)
        };
      }
    }
  }, {
    key: "serialize",
    value: function serialize() {
      // select2 saves {id, text} instead
      return typeof this.model === 'string' ? this.model : this.model.id;
    }
  }]);
  return LanguagePicker;
}();
module.exports = angular.module('backstage.components.common.language-picker', []).component('bsLanguagePicker', {
  templateUrl: '/src/angular/components/common/language-picker/language-picker.html',
  bindings: {
    model: '<',
    required: '<',
    disabledLangs: '<',
    onChange: '&',
    modalRegisterSerialize: '&'
  },
  controller: LanguagePicker
}).name;